import { Component, Input, AfterViewInit, ElementRef, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import flatpickr from 'flatpickr';
import { Spanish } from "flatpickr/dist/l10n/es.js";

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent
  implements AfterViewInit, ControlValueAccessor
{
  @Input() placeholder: string = 'dd/mm/aaaa';
  @Input() maxDate: Date | string | null = null;
  @Input() minDate: Date | string | null = null;
  @Input() error: boolean = false;

  @ViewChild('input') input!: ElementRef;

  private flatpickrInstance: any;
  private onChange = (value: any) => {};
  private onTouched = () => {};
  private baseClasses =
    'w-full p-3 text-md bg_color text-white rounded-lg focus_line_customize focus_line_color_customize appearance-none cursor-pointer h-12 leading-6';

  ngAfterViewInit() {
    // flatpickr(this.input.nativeElement, {
    //   dateFormat: 'd/m/Y',
    //   locale: Spanish,
    //   maxDate: this.maxDate ?? undefined,
    //   minDate: this.minDate ?? undefined,
    //   onChange: (selectedDates, dateStr) => {
    //     this.onChange(dateStr);
    //     this.onTouched();
    //   },
    // });
    this.flatpickrInstance = flatpickr(this.input.nativeElement, {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd/m/Y',
      locale: Spanish,
      maxDate: this.maxDate ?? undefined,
      minDate: this.minDate ?? undefined,
      onChange: (selectedDates, dateStr) => {
        this.onChange(dateStr);
        this.onTouched();
      },
    });
    
  }
  
  writeValue(value: any): void {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.setDate(value ?? null, false);
    } else if (this.input?.nativeElement) {
      this.input.nativeElement.value = value ? value : '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
